/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';

import Colors from 'constants/Colors';

export const BorderSwitch = styled.div`
  background: ${Colors.GRAY[6]}
  padding-left: 1px;
  border-radius: 14px;
  width: 57px;
  padding-top: 1px;
  padding-right: 1px;
  height: 30px;
  display: -webkit-inline-box;
  margin-left: 5px;
      ${({marginBottom}) => marginBottom || marginBottom == 0 ? `margin-bottom: ${marginBottom}px` : `margin-bottom: 36px`};
`;